(function() {
    $('.navbar__button').on('click', function () {
        event.preventDefault();
        $(this).toggleClass('open');
        $('.nav__panel').toggleClass('open');
    });
})();
